import React, { useCallback, useState } from 'react'
import { GoogleMap, Marker } from '@react-google-maps/api'

const containerStyle = {
  width: '100%',
  height: '400px',
  marginBottom: '20px',
  borderRadius: '8px'
}

function DeliveryGroupMap({ restaurant, stops, orders, riderLocation }) {
  // Initialize map center with restaurant location
  const center = {
    lat: parseFloat(restaurant.location.coordinates[1]),
    lng: parseFloat(restaurant.location.coordinates[0])
  }

  // Build dropoff markers from stops (with location) or legacy orders
  const dropoffMarkers = stops?.length
    ? stops
        .filter(s => s.type === 'DROPOFF' && s.location?.coordinates?.length >= 2)
        .map((stop, index) => ({
          key: stop.stopId,
          position: {
            lat: parseFloat(stop.location.coordinates[1]),
            lng: parseFloat(stop.location.coordinates[0])
          },
          label: (index + 1).toString(),
          title: stop.address || `Delivery #${index + 1}`
        }))
    : (orders || []).map((order, index) => ({
        key: order._id,
        position: {
          lat: parseFloat(order.deliveryAddress?.location?.coordinates?.[1]),
          lng: parseFloat(order.deliveryAddress?.location?.coordinates?.[0])
        },
        label: (index + 1).toString(),
        title: order.deliveryAddress?.deliveryAddress || `Delivery #${index + 1}`
      })).filter(m => !isNaN(m.position.lat) && !isNaN(m.position.lng))

  // Custom marker style for order stops
  const getOrderMarkerIcon = () => ({
    path: window.google.maps.SymbolPath.CIRCLE,
    fillColor: '#2196F3',
    fillOpacity: 1,
    strokeWeight: 2,
    strokeColor: '#FFFFFF',
    scale: 15,
    labelOrigin: new window.google.maps.Point(0, 0)
  })

  return (
    // <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={12}
      >
        {/* Restaurant marker */}
        <Marker
          position={center}
          icon={{
            url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
            labelOrigin: new window.google.maps.Point(0, -32),
          }}
          label={{
            text: 'Restaurant',
            color: '#000000',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        />

        {/* Rider location marker */}
        {riderLocation && riderLocation.location && riderLocation.location.coordinates && (
          <Marker
            key={`rider-${riderLocation.location.coordinates[0]}-${riderLocation.location.coordinates[1]}`}
            position={{
              lat: parseFloat(riderLocation.location.coordinates[1]),
              lng: parseFloat(riderLocation.location.coordinates[0])
            }}
            icon={{
              url: 'https://maps.google.com/mapfiles/kml/pal4/icon15.png',
              scaledSize: new window.google.maps.Size(40, 40),
            }}
            // label={{
            //   text: 'Rider',
            //   color: '#000000',
            //   fontSize: '14px',
            //   fontWeight: 'bold'
            // }}
            title="Rider Location"
          />
        )}

        {/* Dropoff stop markers */}
        {dropoffMarkers.map((marker) => (
          <Marker
            key={marker.key}
            position={marker.position}
            icon={getOrderMarkerIcon()}
            label={{
              text: marker.label,
              color: '#FFFFFF',
              fontSize: '12px',
              fontWeight: 'bold'
            }}
            title={marker.title}
          />
        ))}
      </GoogleMap>
    // </LoadScript>
  )
}

export default DeliveryGroupMap 